{
  "vitalsEntry": {
    "title": "Dấu hiệu sinh tồn",
    "subtitle": "Ghi nhận và xem lại dấu hiệu sinh tồn",
    "printLabel": "In dấu hiệu sinh tồn",
    "recordSection": "Ghi nhận dấu hiệu sinh tồn",
    "save": "Ghi nhận dấu hiệu sinh tồn",
    "cancel": "Hủy",
    "saving": "Đang ghi nhận...",
    "recordedSuccess": "Đã ghi nhận dấu hiệu sinh tồn thành công",
    "recordedError": "Ghi nhận dấu hiệu sinh tồn thất bại",
    "invalidEncounter": "Mã lượt khám không hợp lệ.",
    "historyTitle": "Dấu hiệu sinh tồn gần đây",
    "loadingHistory": "Đang tải dấu hiệu sinh tồn...",
    "loadError": "Tải dấu hiệu sinh tồn thất bại.",
    "emptyHistory": "Chưa có dấu hiệu sinh tồn nào được ghi nhận cho lượt khám này.",
    "morseTitle": "Thang đo nguy cơ té ngã Morse",
    "bradenTitle": "Thang đo nguy cơ loét tì đè Braden",
    "riskScalesSaved": "Đã ghi nhận điểm nguy cơ thành công",
    "riskScalesFailed": "Đã lưu dấu hiệu sinh tồn, nhưng ghi nhận điểm nguy cơ thất bại"
  },
  "vitals": {
    "systolic": "Huyết áp tâm thu",
    "diastolic": "Huyết áp tâm trương",
    "heartRate": "Nhịp tim",
    "respiratoryRate": "Nhịp thở",
    "temperature": "Nhiệt độ",
    "oxygenSaturation": "Độ bão hòa oxy (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "Điểm đau",
    "weight": "Cân nặng",
    "height": "Chiều cao",
    "bmi": "BMI",
    "rangeError": "{{field}} phải nằm trong khoảng từ {{min}} đến {{max}}",
    "placeholders": {
      "temperature": "ví dụ: 37.0",
      "heartRate": "ví dụ: 72",
      "respiratoryRate": "ví dụ: 16",
      "oxygenSaturation": "ví dụ: 98",
      "systolic": "ví dụ: 120",
      "diastolic": "ví dụ: 80",
      "weight": "ví dụ: 70.5",
      "height": "ví dụ: 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "Bình thường",
    "borderline": "Giáp ranh",
    "abnormal": "Bất thường",
    "critical": "Nguy kịch"
  },
  "tableHeaders": {
    "dateTime": "Ngày/Giờ",
    "temperature": "Nhiệt độ",
    "heartRate": "Nhịp tim",
    "respiratoryRate": "Nhịp thở",
    "bloodPressure": "Huyết áp",
    "oxygenSaturation": "SpO2",
    "weight": "Cân nặng",
    "height": "Chiều cao",
    "pain": "Đau"
  },
  "io": {
    "title": "Lượng dịch vào / ra",
    "addRecord": "Thêm bản ghi",
    "addRecordSection": "Thêm bản ghi dịch vào/ra",
    "loading": "Đang tải bản ghi dịch vào/ra...",
    "loadError": "Tải bản ghi dịch vào/ra thất bại.",
    "empty": "Chưa có bản ghi dịch vào/ra cho lượt khám này.",
    "totals": {
      "intake": "Tổng dịch vào",
      "output": "Tổng dịch ra",
      "balance": "Cân bằng ròng",
      "totalsRow": "Tổng",
      "netLabel": "Ròng"
    },
    "negativeWarning": "Cân bằng âm — kiểm tra tình trạng dịch",
    "columns": {
      "dateTime": "Ngày/Giờ",
      "type": "Loại",
      "category": "Phân loại",
      "amount": "Lượng (ml)",
      "notes": "Ghi chú"
    },
    "fields": {
      "type": "Loại",
      "category": "Phân loại",
      "amount": "Lượng (ml)",
      "notes": "Ghi chú"
    },
    "type": {
      "intake": "Dịch vào",
      "output": "Dịch ra"
    },
    "categoryPlaceholder": "Chọn phân loại...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "Ghi chú tùy chọn...",
    "save": "Lưu bản ghi",
    "cancel": "Hủy",
    "missingValueShort": "--",
    "toast": {
      "added": "Đã thêm bản ghi dịch vào/ra",
      "addFailed": "Thêm bản ghi dịch vào/ra thất bại",
      "missingFields": "Vui lòng điền các trường bắt buộc"
    }
  },
  "intake": {
    "oral": "Đường uống",
    "iv": "IV",
    "bloodProducts": "Chế phẩm máu",
    "tpn": "TPN",
    "tubeFeeding": "Nuôi qua sonde",
    "other": "Khác"
  },
  "output": {
    "urine": "Nước tiểu",
    "drain": "Dẫn lưu",
    "emesis": "Chất nôn",
    "stool": "Phân",
    "bloodLoss": "Mất máu",
    "ngSuction": "Hút NG",
    "other": "Khác"
  },
  "wound": {
    "title": "Hồ sơ chăm sóc vết thương",
    "subtitle": "Lượt khám #{{id}} — Đánh giá vết thương có cấu trúc",
    "newAssessment": "Đánh giá vết thương mới",
    "dimensionsTitle": "Kích thước (cm)",
    "woundBedTitle": "Nền vết thương (%)",
    "woundBedTotalWarning": "Tổng: {{total}}% (cần đạt 100%)",
    "woundBedTotalOk": "Tổng: 100%",
    "previousTitle": "Đánh giá trước đây",
    "empty": "Chưa có đánh giá vết thương cho lượt khám này.",
    "invalidEncounter": "Mã lượt khám không hợp lệ.",
    "save": "Lưu đánh giá",
    "savedSuccess": "Đã ghi nhận đánh giá vết thương",
    "savedError": "Lưu đánh giá vết thương thất bại",
    "fields": {
      "woundType": "Loại vết thương",
      "location": "Vị trí",
      "stage": "Giai đoạn",
      "length": "Chiều dài",
      "width": "Chiều rộng",
      "depth": "Chiều sâu",
      "granulation": "Mô hạt",
      "slough": "Mô hoại tử mềm",
      "eschar": "Vảy hoại tử khô",
      "epithelial": "Mô biểu mô",
      "drainageType": "Loại dịch tiết",
      "drainageAmount": "Lượng dịch tiết",
      "surroundingSkin": "Da xung quanh",
      "treatment": "Xử trí đã áp dụng",
      "painScore": "Điểm đau (0-10)",
      "notes": "Ghi chú"
    },
    "placeholders": {
      "length": "ví dụ: 3.5",
      "width": "ví dụ: 2.0",
      "depth": "ví dụ: 0.5",
      "treatment": "Mô tả xử trí chăm sóc vết thương đã áp dụng...",
      "notes": "Quan sát bổ sung..."
    },
    "history": {
      "dimensionsLabel": "Kích thước",
      "drainageLabel": "Dịch tiết",
      "painLabel": "Đau",
      "treatmentLabel": "Xử trí"
    },
    "stage": {
      "stage1": "Giai đoạn 1",
      "stage2": "Giai đoạn 2",
      "stage3": "Giai đoạn 3",
      "stage4": "Giai đoạn 4",
      "unstageable": "Không xác định giai đoạn",
      "deepTissue": "Tổn thương mô sâu",
      "na": "N/A"
    },
    "drainageType": {
      "none": "Không có",
      "serous": "Dịch trong",
      "sanguineous": "Dịch máu",
      "serosanguineous": "Dịch trong lẫn máu",
      "purulent": "Dịch mủ"
    },
    "drainageAmount": {
      "none": "Không có",
      "scant": "Rất ít",
      "small": "Ít",
      "moderate": "Trung bình",
      "large": "Nhiều",
      "copious": "Rất nhiều"
    },
    "woundType": {
      "pressure": "Loét do tì đè",
      "surgical": "Vết mổ",
      "diabetic": "Loét đái tháo đường",
      "venous": "Loét tĩnh mạch",
      "arterial": "Loét động mạch",
      "traumatic": "Chấn thương",
      "skinTear": "Rách da",
      "other": "Khác"
    },
    "location": {
      "sacrum": "Xương cùng",
      "coccyx": "Xương cụt",
      "leftHeel": "Gót chân trái",
      "rightHeel": "Gót chân phải",
      "leftTrochanter": "Mấu chuyển trái",
      "rightTrochanter": "Mấu chuyển phải",
      "abdomen": "Bụng",
      "leftLeg": "Chân trái",
      "rightLeg": "Chân phải",
      "back": "Lưng",
      "other": "Khác"
    },
    "surroundingSkin": {
      "intact": "Nguyên vẹn",
      "erythema": "Hồng ban",
      "macerated": "Mủn da",
      "indurated": "Cứng",
      "edematous": "Phù",
      "warm": "Nóng",
      "discolored": "Đổi màu"
    }
  },
  "carePlan": {
    "title": "Kế hoạch chăm sóc",
    "addPlan": "Thêm kế hoạch chăm sóc",
    "newPlan": "Kế hoạch chăm sóc mới",
    "createPlan": "Tạo kế hoạch",
    "cancel": "Hủy",
    "empty": "Chưa có kế hoạch chăm sóc nào cho bệnh nhân này.",
    "emptyGoals": "Chưa thiết lập mục tiêu.",
    "goals": "Mục tiêu",
    "addGoal": "Thêm mục tiêu",
    "saving": "Đang lưu...",
    "loading": "Đang tải kế hoạch chăm sóc...",
    "loadError": "Tải kế hoạch chăm sóc thất bại.",
    "fields": {
      "title": "Tiêu đề",
      "startDate": "Ngày bắt đầu",
      "targetDate": "Ngày mục tiêu",
      "description": "Mô tả",
      "target": "Mục tiêu"
    },
    "placeholders": {
      "title": "ví dụ: Kế hoạch phòng ngừa té ngã",
      "description": "Mô tả mục tiêu",
      "target": "ví dụ: Không té ngã trong 30 ngày"
    },
    "history": {
      "startLabel": "Bắt đầu",
      "targetLabel": "Mục tiêu",
      "goalsLabel": "Mục tiêu"
    },
    "status": {
      "active": "Đang thực hiện",
      "completed": "Hoàn thành",
      "cancelled": "Đã hủy"
    },
    "goalStatus": {
      "inProgress": "Đang thực hiện",
      "achieved": "Đạt được",
      "notAchieved": "Chưa đạt"
    },
    "toast": {
      "planCreated": "Đã tạo kế hoạch chăm sóc",
      "planCreateFailed": "Tạo kế hoạch chăm sóc thất bại",
      "goalAdded": "Đã thêm mục tiêu",
      "goalAddFailed": "Thêm mục tiêu thất bại",
      "planValidation": "Tiêu đề và ngày bắt đầu là bắt buộc",
      "goalValidation": "Mô tả và mục tiêu là bắt buộc"
    }
  }
}
